"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RecordForm = require("./RecordForm");
Object.keys(_RecordForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RecordForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RecordForm[key];
    }
  });
});
var _RecordingSettings = require("./RecordingSettings");
Object.keys(_RecordingSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RecordingSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RecordingSettings[key];
    }
  });
});